import { render } from "./Fonts.vue?vue&type=template&id=22c9a60b&scoped=true"
import script from "./Fonts.vue?vue&type=script&lang=js"
export * from "./Fonts.vue?vue&type=script&lang=js"

import "./Fonts.vue?vue&type=style&index=0&id=22c9a60b&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c9a60b"]])

export default __exports__